<template lang="pug">
.crud
  div(v-if="has_permission")
    modal-revisions(:revision='revision', :is-add='isModalAdd' :isQuote="isQuote" :customer="isCustomer")
    .container-fluid
      vm-row.separador-row(vm-w="12" :class="{ heading : isQuote }")
        vm-col(vm-lg=6 vm-sm=6)
          router-link(v-if="isQuote" :to="{name: 'quotes'}")
            vm-button(icon="arrow-back-outline" radius)
        vm-col(vm-type="flex" vm-justify="flex-end" vm-lg=6 vm-sm=6)
          div
            vm-button(icon="plus" @click="addRevision" v-if="revisions_store_permission && inOrder.status != 5") {{ $t('strings.add') }}
      vm-row(vm-w="12")
        vm-col(vm-sm=12 :class="{ card : isQuote }")
          vm-table(v-model="selected" :data="revisions")
            template(slot="header")
              .d-flex.justify-content-between
                div
            template(slot="thead")
              vm-th(:key="index" v-if="column !== 'id' && column != 'recept_date' && column != 'starting_date' && column != 'end_date'" v-for="(column, index) in columns") {{ $t('revisions.' + column) }}
              vm-th(v-if="isQuote") {{ $t('projects.recept_date') }}
              vm-th(v-if="!isQuote") {{ $t('revisions.starting_date') }}
              vm-th(v-if="!isQuote") {{ $t('revisions.end_date') }}
              vm-th

            template(slot-scope="{data}")
              vm-tr(:data="tr" :key="indextr" v-for="(tr, indextr) in data")
                vm-td(:data="data[indextr][column]" :key="index" v-if="column !== 'id'" v-for="(column, index) in columns")
                  slot(v-if="column != 'status' && column != 'total' && column != 'approved' && column != 'created_by' && column != 'type'") {{data[indextr][column]}}
                  slot(v-if="column == 'created_by'") {{data[indextr]['user']['name']}}
                  iconRevission(v-if="column == 'approved'" :approved="data[indextr]['approved'] == 1 ? true : false")
                  vm-chip(v-if="column == 'type'") {{ data[indextr]['type_display']}}
                  vm-status-indicator(v-if="column == 'status'" :pulse="data[indextr]['status'] !== 'Activo'" :color="colorStatus(data[indextr]['status'])") {{data[indextr]['status_display']}}
                vm-td(v-if="isQuote")
                  slot {{data[indextr]['starting_date']}}
                vm-td(v-if="!isQuote")
                  slot {{data[indextr]['starting_date']}}
                vm-td(v-if="!isQuote")
                  slot {{data[indextr]['end_date']}}
                vm-td
                  vm-dropdown(vm-custom-content vm-trigger-click vm-trigger-outside-click)
                    vm-button(type="flat" icon="more-horizotnal" color="#afbbc6")

                    vm-dropdown-menu
                      vm-dropdown-item.d-flex.justify-content-between(@click="addEndDate(data[indextr], tr)" v-if="!isQuote && !data[indextr]['end_date'] && revisions_update_permission")
                        vm-icon(icon="edit-2-outline")
                        slot &nbsp;{{ $t('revisions.end_date') }}
                      vm-dropdown-item.d-flex.justify-content-between(@click="deleteRevisionConfirm(data[indextr])" v-if="revisions_update_permission")
                        vm-icon(icon="trash-2-outline")
                        slot &nbsp;{{ $t('strings.delete') }}
                      vm-dropdown-item.d-flex.justify-content-between(@click="isQuote ? approvedRevisionQuote(data[indextr]) : approvedRevision(data[indextr])" v-if="data[indextr]['approved'] == 0 && revisions_update_permission")
                        vm-icon(icon="checkmark-circle-2-outline")
                        slot &nbsp;{{ $t('strings.approved') }}
                      vm-dropdown-item.d-flex.justify-content-between(@click="openViewer(data[indextr], indextr)" v-if="data[indextr].attachment && data[indextr].attachment.filename && revisions_update_permission")
                        vm-icon(icon="eye-outline")
                        slot &nbsp;{{ $t('revisions.see_attachment') }}
  #no-access(v-else)
    access-denied
</template>
<script>
import moment from 'moment'
import { createNamespacedHelpers } from 'vuex'
const { mapGetters, mapActions } = createNamespacedHelpers('InOrders')

export default {
  name: 'Revisions',
  components: {
    ModalRevisions: () => import('@/components/in-order/ModalRevisions.vue'),
    AccessDenied: () => import('@/components/aditionals/AccessDenied.vue'),
    iconRevission: () => import('@/components/aditionals/iconRevission.vue')
  },
  data: () => ({
    revision: {},
    selected: [],
    isQuote: false,
    isModalAdd: true,
    has_permission: true,
    revisions_store_permission: true,
    revisions_update_permission: true,
    customer: true,
    isCustomer: true,
    columns: [
      'revision_number',
      'package_name',
      'type',
      'status',
      'created_by',
      'approved',
      'approved_date'
    ],
    status: [
      {
        text: 'Open',
        value: 1,
        color: 'success'
      },
      {
        text: 'Close',
        value: 2,
        color: 'danger'
      }
    ]
  }),
  async created () {
    this.checkPermission('revisions.index')
    this.$route.params.idQuote && await this.getInOrder()
  },
  methods: {
    ...mapActions([
      'setLoading',
      'setModalRevisionVisible',
      'deleteRevision',
      'approvedRevision',
      'approvedRevisionQuote',
      'loadRevisions',
      'loadInOrder'
    ]),
    checkPermission (permission) {
      this.has_permission = this.$auth.user().view_permissions.findIndex(e => e.name === permission) > -1
      this.revisions_store_permission = this.$auth.user().view_permissions.findIndex(e => e.name === 'revisions.store') > -1
      this.revisions_update_permission = this.$auth.user().view_permissions.findIndex(e => e.name === 'revisions.update') > -1
      this.customer = this.$auth.user().view_roles.findIndex(e => e === 'Customer') > -1
    },
    async getInOrder (page) {
      this.loadInOrder(this.$route.params.idQuote)
      this.isQuote = true
    },
    colorStatus (code) {
      return this.status.find(e => e.value === parseInt(code))['color']
    },
    addRevision () {
      this.isModalAdd = true
      this.isCustomer = this.customer
      this.revision = {
        starting_date: moment().format('YYYY-MM-DD'),
        end_date: moment().format('YYYY-MM-DD'),
        type: this.$route.params.idQuote ? 1 : 2
      }
      this.setModalRevisionVisible(true)
    },
    addEndDate (revision, index) {
      this.isModalAdd = false
      this.revision = { ...revision }
      this.revision.end_date = moment().format('YYYY-MM-DD')
      this.setModalRevisionVisible(true)
    },
    async deleteRevisionConfirm (revision) {
      let t = this
      this.auxDeleteRevision = () => {
        t.deleteRevision(revision).then(() => { t.selected = [] })
      }
      this.$vm.dialog({
        color: 'danger',
        title: this.$t('front.delete_modal'),
        text: this.$t('front.delete_confirmation', { model: this.$t('strings.revision'), attribute: this.$t(revision.id) }),
        accept: this.auxDeleteRevision
      })
    },
    openViewer (revision) {
      this.$viewer.show({
        urlFile: revision.attachment.file_url,
        mime: revision.attachment.mime_type,
        name: revision.attachment.filename,
        color: '#FFF'
      })
    }
  },
  computed: {
    ...mapGetters([
      'inOrder'
    ]),
    revisions () {
      if (this.isQuote) {
        if (this.customer) {
          return this.inOrder.revisions_quote.filter(revisions => revisions.type === 2)
        } else {
          return this.inOrder.revisions_quote
        }
      } else {
        if (this.customer) {
          return this.inOrder.revisions.filter(revisions => revisions.type === 2)
        } else {
          return this.inOrder.revisions
        }
      }
    }
  }
}
</script>
<style lang="scss" scoped>
  .card {
    background: white;
    -webkit-box-shadow: 0px 4px 9px -5px rgba(0,0,0,0.15);
    -moz-box-shadow: 0px 4px 9px -5px rgba(0,0,0,0.15);
    box-shadow: 0px 4px 9px -5px rgba(0,0,0,0.15);
  }
  .separador-row {
    margin: 20px 5px;
  }
  .filters {
  .filter {
    padding: 5px 10px;
    width: 250px;
  }
  }
  .con-vm-tooltip {
  display: inline-block;
  position: relative;
  }
  .vm-table--header {
  padding: 10px;
  span {
    width: 100%;
    .justify-content-between {
      div:last-child {
        .vm-button {
          margin: 0 3px;
        }
        .vm-con-dropdown {
          float: left;
        }
        .con-select {
          display: inline-block;
          input {
            height: 32px;
          }
        }
      }
    }
  }
}
</style>
